module.exports = __webpack_public_path__ + "img/icon.ca3263be.png";